import View from "./View";

class SearchItemView extends View {
  _modalContainerSearch = document.querySelector(".modal-container-search");
  _searchField = document.querySelector(".search-field");
  _searchForm = document.querySelector(".modal-container-search .search-form");
  _searchIcon = document.querySelector(".section-header-opening .search-icon");

  _clearInput() {
    this._searchForm.querySelector(".search-field").value = "";
  }

  closeModalSearch() {
    this._modalContainerSearch.onclick = (event) => {
      if (event.target === this._modalContainerSearch) {
        // Hide search modal
        this._overlaySearch.style.display = "none";

        // Show scroll bar
        document.body.style.overflow = "visible";
      }
    };
  }

  getQuery() {
    const query = this._searchForm.querySelector(".search-field").value.trim();
    this._clearInput();
    return query;
  }

  getQueryOnLoad() {
    // Get name of searched product
    const parsedUrl = new URL(window.location.href);
    const query = parsedUrl.searchParams.get("search");

    this._clearInput();
    return query;
  }

  // Open modal Search
  openModalSearch() {
    // Show modal
    this._overlaySearch.style.display = "block";

    // Hide scroll bar
    document.body.style.overflow = "hidden";

    // Focus cursor on input text field
    this._searchField.focus();
  }

  renderOnClickSearch() {
    this._searchIcon.onclick = () => {
      this.openModalSearch();
      this.closeModalSearch();
    };
  }

  search(handler) {
    this._searchForm.addEventListener("submit", (event) => {
      // Prevent form submission
      event.preventDefault();
      handler();
    });
  }
}

export default new SearchItemView();
